const route = [
    {
        path: '/activity/2023qz/index', //2023下期中检测
        component: function (resolve) {
            require(['VIEWS/activity/2023qz/index.vue'], resolve);
        }
    },
]
export default route;
